import React from 'react';

import styles from './FundManagerSummary.css';

import { displayShortDate } from '../../utils/Format/Format';

import fallbackImg from '../../images/no_photo_small.png';

const FundManagerSummary = (props) => {
    if (!props.data) return null;
    const { fundManagers } = props.data;

    const showFootNoteSymbol = () => {
        if (props.ticker === 'TUHYX' || props.ticker === 'TUHIX') {
            return <sup>**</sup>;
        }
        return '';
    };

    return (
        <React.Fragment>
            <div className="container">
                {fundManagers.map(
                    ({
                        managerName,
                        managedFundSinceDate,
                        headShots2,
                        title
                    }) => {
                        const headshotImg = (headShots2 || []).find(
                            // (ele) => ele.displayName === 'x96(bw)'
                            (ele) =>
                                (ele.width === 96 && ele.height === 96) ||
                                (ele.width === 128 && ele.height === 128)
                        );

                        const imgUrl = headshotImg
                            ? `${headshotImg.path}`
                            : fallbackImg;

                        return (
                            <div className="row" key={managerName}>
                                <img
                                    className="manager-image"
                                    alt={managerName}
                                    src={imgUrl}
                                />
                                <div className="manager-content">
                                    <div className="category-title">
                                        {title}
                                    </div>
                                    <div className="category-title-2">
                                        {managerName}
                                    </div>
                                    <div className="category-title">
                                        MANAGED FUND SINCE
                                    </div>
                                    <div className="category-title-2">
                                        {displayShortDate(managedFundSinceDate)}
                                        {showFootNoteSymbol()}
                                    </div>
                                </div>
                            </div>
                        );
                    }
                )}
            </div>
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

export default FundManagerSummary;
